<template>
  <b-modal
    centered
    ref="popup_modal"
    hide-footer
    hide-header
    v-bind="$attrs"
    :size="popupSize"
    :no-enforce-focus="true"
  >
    <div class="popup-header">
      <slot name="header">Title</slot>
    </div>
    <div class="popup-body">
      <slot name="body">Body</slot>
    </div>
    <div class="popup-footer">
      <template v-if="customFooter">
        <slot name="footer">Footer</slot>
      </template>
      <template v-else>
        <button type="button" class="btn-green" @click="onGreenClick">{{ greenButtonTitle }}</button>
        <button type="button" v-if="showRedButton" class="btn-red" @click="onRedClick">{{ redButtonTitle }}</button>
      </template>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    customFooter: {
      type: Boolean,
      default: false,
    },
    showRedButton: {
      type: Boolean,
      default: false,
    },
    redButtonTitle: {
      type: String,
      default: 'Red',
    },
    greenButtonTitle: {
      type: String,
      default: 'Green',
    },
    popupSize: {
      // xl: very large
      // lg: large
      // sm: small
      type: String,
      required: false,
    },
  },
  methods: {
    show() {
      this.$refs['popup_modal'].show();
    },
    hide() {
      this.$refs['popup_modal'].hide();
    },
    onGreenClick() {
      this.hide();
      this.$emit('greenClick');
    },
    onRedClick() {
      this.hide();
      this.$emit('redClick');
    },
  },
};
</script>

<style scoped>
.popup-header {
  margin-top: 5px;
  margin-left: 10px;
}
.popup-body {
  margin-top: 20px;
  margin-left: 10px;
}
.popup-footer {
  text-align: right;
}
.btn-green {
  margin-right: 10px;
  box-shadow: none;
  border: none;
  background-color: #42b195;
  color: white;
  border-radius: 7px;
  padding: 10px 32px;
  margin-top: 30px;
  margin-bottom: 10px;
}
.btn-red {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
